import { render, staticRenderFns } from "./virtualVisit.vue?vue&type=template&id=35043784&scoped=true"
import script from "./virtualVisit.vue?vue&type=script&lang=ts"
export * from "./virtualVisit.vue?vue&type=script&lang=ts"
import style0 from "./virtualVisit.vue?vue&type=style&index=0&id=35043784&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35043784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35043784')) {
      api.createRecord('35043784', component.options)
    } else {
      api.reload('35043784', component.options)
    }
    module.hot.accept("./virtualVisit.vue?vue&type=template&id=35043784&scoped=true", function () {
      api.rerender('35043784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/visitForms/virtualVisit.vue"
export default component.exports